const toggle = () => {
    document.querySelectorAll('.js-index__title').forEach(head => {
        head.addEventListener('click', () => {
            const item = head.closest('.js-index__item');
            const content = item.querySelector('.js-index__content');
            const cursor = head

            // content 表示切り替え
            content.classList.toggle('is-open');

            // cursor direction 切り替え
            if (cursor) {
                const current = cursor.dataset.direction;
                cursor.dataset.direction = current === 'bottom' ? 'right' : 'bottom';
            }
        });
    });
}

const column = () => {
    toggle()
}
export default column;
